export default function (context, val) {
    let form = context.state;
    form.dateType = val.dateType;
    form.CurrencyId = val.CurrencyId;
    form.DepartmentList = val.DepartmentList;
    form.ManagerList = val.ManagerList;
    form.Direction = val.Direction;
    form.ContragentID = val.ContragentID;
    form.ContragentName = val.ContragentName;
    form.ContragentType = val.ContragentType;
    form.ContragentSearchTypeId = val.ContragentSearchTypeId;
    form.AgreementCode = val.AgreementCode;
    form.RequestNumber = val.RequestNumber;
    form.PaymentReason = val.PaymentReason;
    form.DocumentNumber = val.DocumentNumber;
    form.NoDetailedOnly = val.NoDetailedOnly;
    form.AccountNumber = val.AccountNumber;
    form.PaymentOperationID = val.PaymentOperationID;
    form.CategoryId = val.CategoryId;
    form.PaymentTypeId = val.PaymentTypeId;
    form.CashList = val.CashList;
    form.PaymentAccountList = val.PaymentAccountList;
    form.StatementName = val.StatementName;
    form.MinAmount = val.MinAmount;
    form.MaxAmount = val.MaxAmount;
    form.PaySystemTransactionId = val.PaySystemTransactionId;
    form.PaymentMethodId = val.PaymentMethodId;
    form.DateStatement = val.DateStatement;
    form.KindOfPayId = val.KindOfPayId;

    let dFrom = new Date(), dTo = new Date();
    switch (val.dateStep) {
        case 1:
            dFrom.setDate(dFrom.getDate() - val.dateInt);
            break;
        case 2:
            dFrom.setDate(dFrom.getDate() - val.dateInt * 7);
            break;
        case 3:
            dFrom.setMonth(dFrom.getMonth() - val.dateInt);
            if (val.dateRound) {
                dFrom.setDate(1);
            }
            break;
    }

    form.dates = [
        '' + (dFrom.getDate() > 9 ? '' : '0') + dFrom.getDate() + '.' + (dFrom.getMonth() > 8 ? '' : '0') + (dFrom.getMonth() + 1) + '.' + dFrom.getFullYear(),
        '' + (dTo.getDate() > 9 ? '' : '0') + dTo.getDate() + '.' + (dTo.getMonth() > 8 ? '' : '0') + (dTo.getMonth() + 1) + '.' + dTo.getFullYear()
    ];
    if (val.searchClick) {
        context.dispatch('finances/payments/search', null, {root: true});
    }
}